import { gql } from '@apollo/client';

// 查询仓库是否启用司机离职灰度
export const IS_WAREHOUSE_IN_DRIVER_RESIGNATION_GRAY_CONFIG = gql`
    query IsWarehouseInDriverResignationGrayConfig($warehouseId: Long!) {
        isWarehouseInDriverResignationGrayConfig(warehouseId: $warehouseId)
    }
`;

export interface IsWarehouseInDriverResignationGrayConfigResponse {
    isWarehouseInDriverResignationGrayConfig: boolean;
}

export interface IsWarehouseInDriverResignationGrayConfigVariables {
    warehouseId: number;
}
